import React from 'react'

export default function () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 23.813 22.728"
    >
      <path
        fill="#00a396"
        fillRule="evenodd"
        d="M7.71 1.939a.722.722 0 0 1 .387.945l-.202.48 1.803.276a9.386 9.386 0 0 1 5.694 3.162l.076.088a7.942 7.942 0 0 0 4.71 2.658l3.033.51a.722.722 0 0 1 .512 1.06 46.002 46.002 0 0 0-3.849 9.177.722.722 0 0 1-.812.507l-3.037-.51a9.386 9.386 0 0 1-5.566-3.14l-.076-.09a7.942 7.942 0 0 0-4.817-2.675l-2.16-.332-2.018 4.806a.722.722 0 0 1-1.332-.559l6.71-15.977a.722.722 0 0 1 .944-.386Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        stroke="#00a396"
        strokeLinejoin="round"
        strokeWidth="3.969"
        d="M9.348 7.173v2.805l3.783-1.852v11.959h-5.08v2.54h13.124l-1.932-2.54h-3.096V3.866Z"
        aria-label="1"
        paintOrder="stroke fill markers"
        transform="translate(-1.323 -1.882)"
      />
    </svg>
  )
}
